import NBType, { InferType } from '@netbase/nb-type'

const DateRangeSchema = NBType.object().shape('DateRangeSchema', {
  /* @prop */
  end: NBType.timestamp(),
  /* @prop */
  start: NBType.timestamp()
  /* END */
})
export default DateRangeSchema
export type DateRange = InferType<typeof DateRangeSchema>
// RESERVE BELOW
